module.exports = __webpack_public_path__ + "static/media/cart-icon-on-yellow.0b319b3f.svg";